import { Bar, ComposedChart, Label, LabelList, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import CustomizedYAxisTick from "./CustomizedTick";

const StrategicChart = ({ data = [] }) => {


    const render = () => {
        return (
            <ResponsiveContainer width="100%" height={data.length < 4 ? 600 : 150 * data.length}>
                <ComposedChart
                    layout="vertical"
                    data={data}
                    margin={{
                        top: 20,
                        right: 100,
                        bottom: 50,
                        left: 100,
                    }}
                    barGap={0}
                >
                    <Tooltip />
                    <XAxis type="number" orientation="top" tickLine={false} xAxisId='top' >
                        <Label value="Initiatives comparision" position={{ x: -70, y: -20 }} style={{ textAnchor: 'middle', fill: '#333', fontSize: 14, fontWeight: 'bold' }} />
                    </XAxis>
                    <XAxis type="number" orientation="bottom" tickLine={false} xAxisId='bottom' ></XAxis>
                    <YAxis dataKey="name" type="category" scale="band" tickLine={false} tick={<CustomizedYAxisTick />} >
                        <Label value="Initiatives" position={{ x: '-140%', y: '50%' }} angle={-90} style={{ textAnchor: 'middle', fill: '#333', fontSize: 14, fontWeight: 'bold' }} />
                    </YAxis>
                    <Legend verticalAlign="top" content={CustomLegend} />
                    <Bar dataKey="cost" fill="#8884d8" xAxisId={'top'} barSize={30}>
                        <LabelList dataKey="cost" position="right" />
                    </Bar>
                    <Bar dataKey="benefit" fill="#82ca9d" xAxisId={'top'} barSize={30}>
                        <LabelList dataKey="benefit" position="right" />
                    </Bar>
                    <Bar dataKey="npv" fill="#ffc658" xAxisId={'top'} barSize={30}>
                        <LabelList dataKey="npv" position="right" />
                    </Bar>
                    <Bar dataKey="time" fill="#0088FE" xAxisId='bottom' barSize={15}>
                        <LabelList dataKey="time" position="right" />
                    </Bar>
                </ComposedChart>
            </ResponsiveContainer>)
    }
    return render();
};

export default StrategicChart;


const CustomLegend = () => {
    const items = [
        { label: "Cost (M)", color: "#8884d8" },
        { label: "Benifit (M)", color: "#82ca9d" },
        { label: "NPV (M)", color: "#ffc658" },
        { label: "Time (month)", color: "#0088FE" },
    ];

    return (
        <div style={{ display: "flex", justifyContent: 'center', gap: "1rem", paddingTop: '10px' }}>
            {items.map((item) => (
                <div key={item.label} style={{ display: "flex", alignItems: "center" }}>
                    <span
                        style={{
                            backgroundColor: item.color,
                            width: 12,
                            height: 12,
                            display: "inline-block",
                            marginRight: 6,
                        }}
                    />
                    <span>{item.label}</span>
                </div>
            ))}
        </div>
    );
};
